import videojs from 'video.js';
import 'video.js/dist/video-js.css';

const videojs_ = videojs;

export default {
	data() {
		return {
			videojs: videojs_
		}
	}
}